import styled from 'styled-components';
import { Text12Regular, Text18Bold } from '../../utils/Text/Text.styles';

export const ShareSheet = styled.div`
  width: 100%;
  max-height: calc(100dvh - 1.2rem);
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.06) 0%, rgba(0, 0, 0, 0.2) 100%), #18181a;
  border-radius: 2rem 2rem 0 0;
  padding: 0 1.6rem calc(3.2rem + env(safe-area-inset-bottom));
  overflow-y: auto;

  @media (min-width: 761px) {
    max-width: 46.8rem;
    max-height: min(40rem, calc(100dvh - 4.8rem));
    border-radius: 2rem;
    padding: 0 1.6rem 1.6rem;
  }
`;

export const SheetHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.8rem 0 1.6rem;
`;

export const ShareTitle = styled(Text18Bold)`
  color: #fff;
  font-weight: 600;
`;

export const CloseButton = styled.button`
  width: 4rem;
  height: 4rem;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;

  svg {
    width: 1.6rem;
    height: 1.6rem;
    color: #fff;
  }
`;

export const ShareOptionsScroller = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ $columns = 1 }) => $columns}, minmax(0, 1fr));
  gap: 0.8rem;
  padding-bottom: 0.8rem;
`;

export const ShareOptionButton = styled.button`
  width: ${({ $fullWidth }) => ($fullWidth ? '100%' : 'auto')};
  height: 7rem;
  border-radius: 12px;
  border: 0.5px solid rgba(255, 255, 255, 0.1);
  background: radial-gradient(58.43% 107.51% at 4.82% 0%, rgba(255, 255, 255, 0.05) 0%, rgba(0, 0, 0, 0) 100%), #313134;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  color: #fff;
  cursor: pointer;
  transition:
    border-color 0.18s ease,
    background 0.18s ease,
    transform 0.18s ease;

  &:active {
    transform: scale(0.985);
  }

  @media (hover: hover) {
    &:hover {
      border-color: rgba(255, 255, 255, 0.2);
    }
  }
`;

export const ShareOptionLabel = styled(Text12Regular)`
  color: #fff;
  text-align: center;
  line-height: 2.2rem;
  letter-spacing: -0.043rem;
`;
